// Pure functions that modify incoming string values and return string values, including regex
export const properCase = (word: string): string => {
  return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
}
export const createMultilineSentence = (
  sentence: string,
  maxCharsPerLine: number
): string => {
  const wlArray = sentence.split(' ').map((item) => item.length)
  const maxWordLength = Math.max(...wlArray)
  let newMaxNumberOfCharsPerLine
  if (maxWordLength > maxCharsPerLine) {
    newMaxNumberOfCharsPerLine = maxWordLength
  } else {
    newMaxNumberOfCharsPerLine = maxCharsPerLine
  }
  const newestNumberOfLines = Math.floor(sentence.length / newMaxNumberOfCharsPerLine) + 1
  switch (newestNumberOfLines) {
    case 1:
      return sentence
    case 2:
      return handleCase2(sentence, wlArray)
    default:
      return handleCase3(sentence)
  }
}
/**
 * Appends the first line and 2nd line words by comparing whichever one happens to be longer at that given moment
 * The end result is a two line string with the least length difference between the first and second line
 * @param sentence
 */
function handleCase2 (sentence: string, wlArray:Array<number>) {
  const wordArray = sentence.split(' ')
  let indexSlice = 0
  let frontCounter = 0
  let backCounter = 0
  let numberOfWordsIterated = 0
  for (let i = 0; i < wlArray.length; i++) {
    // compare front to back result
    if (numberOfWordsIterated === wlArray.length) {
      break
    }
    if (i === 0) {
      frontCounter = frontCounter + wlArray[i]
      const indexBack = wlArray.length - i - 1
      const testNumber = wlArray[indexBack]
      backCounter = backCounter + testNumber
      indexSlice++
      numberOfWordsIterated = 2
    } else {
      if (frontCounter > backCounter) {
        backCounter = backCounter + wlArray[wlArray.length - i] + 1
        i--
        numberOfWordsIterated++
      } else {
        frontCounter = frontCounter + wlArray[i] + 1
        numberOfWordsIterated++
        indexSlice++
      }
    }
  }
  const word1 = wordArray.slice(0, indexSlice).join(' ') + '\n'
  const word2 = wordArray.slice(indexSlice, wordArray.length).join(' ')
  const result = word1 + word2 + ''
  return result
}
/**
 * This has a maxCharPerLine cutoff between each line
 * Should the word not fit on the line, it goes to the next one which also adds a \n.
 * this solution goes line by line
 * This is different than handleCase2 which uses a binary algorithm which loops through front and back at same time
 * @param sentence
 */
function handleCase3 (sentence: string) {
  const appNumberOfCharsPerLine = Math.floor(sentence.length / 3) + 1
  let currentLineString = ''
  return sentence.split(' ').reduce((acc, curEl) => {
    if (acc.length === 0) {
      currentLineString = curEl
      return acc + curEl
    } else if (currentLineString.length === 0) {
      currentLineString = curEl
      return acc + ' ' + curEl
    } else if (
      (currentLineString + ' ' + curEl).length <= appNumberOfCharsPerLine
    ) {
      currentLineString = currentLineString + ' ' + curEl
      return acc + ' ' + curEl
    } else {
      currentLineString = ''
      return acc + '\n' + curEl
    }
  }, '')
}
